import { normalize } from "./utils/path.js";
export function createExclude(excludeConfig) {
    const checks = [];
    for (const exclude of excludeConfig) {
        if (typeof exclude === "string") {
            checks.push((path) => path === exclude);
        }
        else {
            checks.push((path) => exclude.test(path));
        }
    }
    return (path) => {
        path = normalize(path);
        return checks.some((check) => check(path));
    };
}
